import FSCss from "../../css/overview.module.css";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { ReactComponent as DeleteIcon } from "../../../myfin_v2/assets/icons/delete_icon_primary.svg";
import { ReactComponent as SearchIcon } from "../../../myfin_v2/assets/icons/searchPri.svg";
import buttoncss from "../../../myfin_v2/css/button.module.css";
import { Button } from "../../../myfin_v2/elements/Button";
import NoteSoftDelete from "../../../Components/templateTabs/NoteSoftDelete/softDelete";
import RestoreSoftDelete from "../../../Components/templateTabs/NoteSoftDelete/restoreSoftDelete";
import { ReactComponent as GreenDot } from "../../assets/icons/greenDotSmall.svg";
import { ReactComponent as AddIcon } from "../../assets/icons/whitePlus.svg";
import { ReactComponent as BackArrow } from "../../assets/icons/left_arrow.svg";
import { ReactComponent as CloseIcon } from "../../assets/icons/close.svg";
import commoncss from "../../css/common.module.css";
import Breadcrumb from "../Breadcrumb";
import Modal from "../../elements/Modal";
import Dropdown from "../../elements/Dropdown";

const PopulateFSTopBar = ({
  history,
  consolID,
  prepopulate = false,
  workspaceName = "Workspace",
  consolName = "Consol",
  activeCat = "BS",
  workspaceID = "",
  showCashflowWorkings = false,
  onToggleCashflowWorkings = () => {},
  showAdjustmentLog = false,
  onOpenAdjustmentLog = () => {},
  onBackFromAdjustmentLog = () => {},
  showAddAdjustment = false,
  onAddAdjustment = () => {},
}) => {
  const [showConfigureModal, setShowConfigureModal] = useState(false);
  const categoryLabels = {
    "BS": "Balance Sheet",
    "PL": "P&L Statement",
    "general notes": "General Notes",
    "cashflow": "CashFlow",
    "socie": "SOCIE",
    "BS notes": "Balance Sheet Notes",
    "PL notes": "P&L Statement Notes",
    "disclosure": "Disclosures",
    "checklist": "Disclosures Checklist"
  };

  const breadcrumbItems = [
    {
      label: workspaceName,
      link: workspaceID ? `/consolidation/${workspaceID}` : `/myfinV2/standalonefs`,
      className: "nav_cnt_color clickable",
    },
    {
      label: consolName,
      link: `/myfinV2/console-prepopulatefs/${consolID}`,
      className: "nav_cnt_color clickable",
    },
    {
      label: `Consol FS - ${categoryLabels[activeCat] || activeCat}`,
      link: "",
      className: "headerLable",
    },
  ];

  const adjustmentBreadcrumbItems = [
    {
      label: workspaceName,
      link: workspaceID ? `/consolidation/${workspaceID}` : `/myfinV2/standalonefs`,
      className: "nav_cnt_color clickable",
    },
    {
      label: consolName,
      link: `/myfinV2/console-prepopulatefs/${consolID}`,
      className: "nav_cnt_color clickable",
    },
    {
      label: "Cashflow Workings",
      onClick: onBackFromAdjustmentLog,
      className: "nav_cnt_color clickable",
    },
    {
      label: showAddAdjustment ? "Add New Adjustment" : "Adjustment Log",
      link: "",
      className: "headerLable",
    }
  ];

  return (
    <div className={FSCss.w100}>
      <div className={FSCss.uploadLoansMainContainer}></div>

      {showAdjustmentLog ? (
        <div className={`${FSCss.listPageheader}`} style={{ padding: "10px 15px", alignItems: "center" }}>
          <div className={FSCss.headerLeftContainer} style={{ width: "auto", display: "flex", alignItems: "center" }}>
            <Breadcrumb
              addCls="bgTransprent"
              p0={true}
              items={adjustmentBreadcrumbItems}
              headerActions={<></>}
              onBackClick={onBackFromAdjustmentLog}
            />
          </div>
          <div className={FSCss.headerRightContainer} id="adjustment-topbar-right"></div>
        </div>
      ) : showCashflowWorkings ? (
        <div 
          className={FSCss.listPageheader}
          style={{ 
            padding: "5px 10px 0px 20px"
          }}
        >
          <div className={FSCss.headerLeftContainer} style={{ display: "flex", alignItems: "center"}}>
            <div className={FSCss.iconContainer} style={{ width: "auto", paddingRight: "15px", paddingLeft: "0" }}>
              <BackArrow className="clickable" style={{ cursor: 'pointer', marginTop: "1px" }} onClick={onToggleCashflowWorkings} />
            </div>
            <div className={FSCss.topBarHeading} style={{ alignContent: "center", cursor: "pointer" }} onClick={() => history.push(workspaceID ? `/consolidation/${workspaceID}` : `/allWorkspace`)}>{workspaceName}</div>
            <div className={FSCss.iconDotContainer}>
              <GreenDot />
            </div>
            <div className={FSCss.topBarHeading} style={{ alignContent: "center", cursor: "pointer" }} onClick={() => history.push(`/myfinV2/console-prepopulatefs/${consolID}`)}>{consolName}</div>
            <div className={FSCss.iconDotContainer}>
              <GreenDot />
            </div>
            <div className={FSCss.topBarHeading} style={{ alignContent: "center", cursor: "pointer" }} onClick={onToggleCashflowWorkings}>Consol FS - CashFlow</div>
            <div className={FSCss.iconDotContainer}>
              <GreenDot />
            </div>
            <div className={commoncss.headerLable} style={{ alignContent: "center" }}>Cashflow Workings</div>
          </div>
          <div className={FSCss.headerRightContainer} style={{ gap: "10px" }}>
            {/* <Button
              btnColor={buttoncss.secondary}
              style={{ backgroundColor: "transparent" }}
              label="Adjustment Log"
              onClick={onOpenAdjustmentLog}
            /> */}
            <Button
              btnColor={buttoncss.primary}
              label={
                <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                  <AddIcon />
                  Add New Adjustment
                </span>
              }
              onClick={onAddAdjustment}
            />
            {prepopulate ? (
              <Button
                btnColor={buttoncss.primary}
                label="Populate FS"
                onClick={() => {
                  history.push(`/myfinV2/console-populatefs/${consolID}`);
                }}
              />
            ) : (
              <Button
                btnColor={buttoncss.primary}
                label="Finalise FS"
                onClick={() => {
                  history.push(`/consol/finalize-fs/${consolID}`);
                }}
              />
            )}
          </div>
        </div>
      ) : (
      <div className={FSCss.listPageheader} style={{ padding: "5px 10px 0px 20px" }}>
        <div className={FSCss.headerLeftContainer} style={{ width: "auto", display: "flex", alignItems: "center" }}>
          <Breadcrumb
            addCls="bgTransprent"
            p0={true}
            items={breadcrumbItems}
            headerActions={<></>}
            backLink={`/myfinV2/console-prepopulatefs/${consolID}`}
          />
        </div>
        <div className={FSCss.headerRightContainer} style={{ gap: "10px" }}>         
          {/* {activeCat === "socie" && (
            <Button
              btnColor={buttoncss.secondary}
              style={{ backgroundColor: "transparent" }}
              label="Configure"
              onClick={() => setShowConfigureModal(true)}
            />
          )} */}
           {activeCat === "cashflow" && (
            <Button
              btnColor={buttoncss.secondary}
              style={{ backgroundColor: "transparent" }}
              label="Cashflow workings"
              onClick={onToggleCashflowWorkings}
            />
          )} 
          {prepopulate ? (
            <Button
              btnColor={buttoncss.primary}
              label="Populate FS"
              onClick={() => {
                history.push(`/myfinV2/console-populatefs/${consolID}`);
              }}
            />
          ) : (
            <Button
              btnColor={buttoncss.primary}
              label="Finalise FS"
              onClick={() => {
                history.push(`/consol/finalize-fs/${consolID}`);
              }}
            />
          )}
        </div>
      </div>
      )}

      {showConfigureModal && (
        <Modal
          title="Configure"
          headerActions={
            <CloseIcon 
              style={{ cursor: "pointer", width: 16, height: 16 }} 
              onClick={() => setShowConfigureModal(false)} 
            />
          }
          width="500px"
          bodyStyle={{ background: "#fff", borderRadius: "0 0 10px 10px", padding: "30px 10px" }}
        >
          <div style={{ display: "flex", flexDirection: "column", gap: "24px" }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <span style={{ fontSize: "14px", fontWeight: "500", color: "#333", minWidth: "120px" }}>Label 1</span>
              <div style={{ flex: 1, maxWidth: "300px" }}>
                <Dropdown placeHolder="Select Option" options={[]} />
              </div>
            </div>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <span style={{ fontSize: "14px", fontWeight: "500", color: "#333", minWidth: "120px" }}>Label 2</span>
              <div style={{ flex: 1, maxWidth: "300px" }}>
                <Dropdown placeHolder="Select Option" options={[]} />
              </div>
            </div>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <span style={{ fontSize: "14px", fontWeight: "500", color: "#333", minWidth: "120px" }}>Label 3</span>
              <div style={{ flex: 1, maxWidth: "300px" }}>
                <Dropdown placeHolder="Select Option" options={[]} />
              </div>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default PopulateFSTopBar;
